/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { ThunkAction } from '@reduxjs/toolkit';
import * as actionTypes from '../constants/action-types';
import { RootState } from '../reducers';
import { AnalyticsEvents } from '../services/analytics/AnalyticsEvents';
import { getAnalytics } from '../services/analytics/AnalyticsService';
import G17Client from '../services/G17Client';

type Thunk = ThunkAction<void, RootState, any, { type: string; }>;

export const showPermissionDenied = (): Thunk => {
  return (dispatch) => dispatch({ type: actionTypes.SHOW_PERMISSION_DENIED })
}

export function hidePermissionDenied(): Thunk {
  return (dispatch) => dispatch({ type: actionTypes.HIDE_PERMISSION_DENIED })
}

export const handleLogin = async (returnPath?: string) => {
  const analytics = getAnalytics();
  await analytics.track(AnalyticsEvents.UserLogin);

  if (returnPath) {
    window.location.href = returnPath;
    return
  }
  // TODO: quickfix
  // we have to refresh the page as there might be a request that has failed, a reload covers this scenario.
  window.location.reload();
};

export function logoutRedirect(returnPath: string) {
  window.location.href = returnPath;
}

export function logout(returnPath?: string) {
  return async () => {
    await G17Client.logout();
    if (returnPath) {
      logoutRedirect(returnPath);
      return
    }

    // quickfix, hard reload to reset state
    window.location.reload();
  }
}

export function setAuthenticationToken(token: string): Thunk {
  return (dispatch) => dispatch({
    type: actionTypes.AUTHENTICATION_TOKEN_LOADED,
    token: token
  })
}

export function unloadAuthenticationToken(): Thunk {
  return (dispatch) => dispatch({
    type: actionTypes.AUTHENTICATION_TOKEN_UNLOADED
  })
}
